import { frontendURL } from '../../../../helper/URLHelper';
import GoogleCalendarIndex from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/google-calendar'),
      name: 'settings_google_calendar',
      meta: {
        permissions: ['administrator'],
      },
      component: GoogleCalendarIndex,
    },
  ],
};
